// extracted by mini-css-extract-plugin
module.exports = {"container":"LandingPage_container__1rE-M","title":"LandingPage_title__Awsbl","btn":"LandingPage_btn__21Wpi"};